import React, { useRef, useLayoutEffect, useCallback } from 'react';
import { ChatInput } from '../../styles/UserWorkspacePageStyles';

const MIN_HEIGHT = 40;
const MAX_LINES = 5;

const ChatMessageInput = ({ value, onChange, onKeyDown, maxLength, placeholder }) => {
  const textareaRef = useRef(null);

  const adjustHeight = useCallback(() => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = 'auto';

    const style = window.getComputedStyle(el);
    const lineHeight = parseFloat(style.lineHeight) || 14.4;
    const verticalExtras =
      parseFloat(style.paddingTop)
      + parseFloat(style.paddingBottom)
      + parseFloat(style.borderTopWidth)
      + parseFloat(style.borderBottomWidth);
    const maxHeight = Math.round(lineHeight * MAX_LINES + verticalExtras);

    const nextHeight = Math.min(Math.max(el.scrollHeight, MIN_HEIGHT), maxHeight);
    el.style.height = `${nextHeight}px`;
    el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
  }, []);

  useLayoutEffect(() => {
    adjustHeight();
  }, [value, adjustHeight]);

  return (
    <ChatInput
      ref={textareaRef}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      maxLength={maxLength}
      placeholder={placeholder}
      rows={1}
    />
  );
};

export default ChatMessageInput;
